export default __webpack_public_path__ + "static/media/wca2.d0280032.jpg";